import React from "react";
import { Platform, View } from "react-native";
import Animated, { useSharedValue } from "react-native-reanimated";

import Icon from "$src/core/components/atoms/Icon";
import Pressable from "$src/core/components/atoms/Pressable";
import Text from "$src/core/components/atoms/Text/Text";
import { TV_PARALLAX } from "$src/core/constants/tv-parallax";
import useScroll from "$src/core/hooks/use-scroll";
import useTranslation from "$src/core/hooks/use-translation";
import $pageInsets from "$src/core/styles/page";

import $, { useAnimatedStyles } from "./BackToTopButton.styles";

type Props = {
  onPress: () => void;
};

const BackToTopButton = ({ onPress }: Props) => {
  const { scrollToTop } = useScroll();
  const { t } = useTranslation();

  const isFocused = useSharedValue(false);

  const { iconContainerStyle } = useAnimatedStyles({ isFocused });

  // Scroll first: Android cannot focus the hero while it sits outside the viewport.
  const handlePress = () => {
    scrollToTop();
    onPress();
  };

  return (
    <Pressable
      accessibilityRole="button"
      onPress={handlePress}
      onFocus={() => isFocused.set(true)}
      onBlur={() => isFocused.set(false)}
      focusable={Platform.isTV}
      tvParallaxProperties={TV_PARALLAX.none}
    >
      <View style={[$.container, $pageInsets.horizontal]}>
        <Animated.View style={[$.iconContainer, iconContainerStyle]}>
          <Icon name="arrow-up" style={$.icon} />
        </Animated.View>
        <Text preset="heading6" accessibilityRole="button">
          {t("COMMON/BACK_TO_TOP")}
        </Text>
      </View>
    </Pressable>
  );
};

export default BackToTopButton;
